export * from 'utils/bolt/showtimes.js';
import hooks from 'utils/hooks';
import parseQueryString from 'utils/parseQueryString';
import { arrayUnique } from 'utils/utils';

hooks.register('showtimes.request.filters.preprocess', filters => {
	const queryFormat = parseQueryString().format;
	if (queryFormat) {
		let formats = [];
		queryFormat.split(',').forEach(f => {
			if (f === 'DOLBY') {
				formats.push('DOLBY');
				formats.push('2D-DOLBY');
			} else if (f === 'D-BOX') {
				formats.push('DBOX');
				formats.push('2D-DBOX');
			} else if (f === 'IMAX-70mm') {
				formats.push('IMAX 70mm');
				formats.push('2D-IMAX-70mm');
			} else {
				formats.push(f);
			}
		});
		filters.format = arrayUnique(formats);
	}
	return filters;
});